import { Close, ExpandMore, Folder, Save } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Mapa from '../../componentes/mapa/Mapa';

const ActividadesTab = ({ actividades, imagenes, editable = false, handleUpdate, setData, setImgs }) => {

    const [catalogoActividades, setCatalogoActividades] = useState([]);
    const getCatalogo = async () => {

        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`)
            .then((res) => res.json())
            .then((respuesta) => {
                setCatalogoActividades(respuesta.data);
            })
    }

    useEffect(() => {
        getCatalogo();
    }, []);

    const [giroSeleccionado, setGiroSeleccionado] = useState('');


    const [giroAbierto, setGiroAbierto] = useState(null);
    const handleOpenGiro = (codigo) => {
        giroAbierto != codigo ? setGiroAbierto(codigo) : setGiroAbierto(null);
    }
    const [productoAbierto, setProductoAbierto] = useState(null);
    const handleOpenProducto = (id) => {
        productoAbierto != id ? setProductoAbierto(id) : setProductoAbierto(null);
    }
    const [unidadAbierta, setUnidadAbierta] = useState(null);
    const handleOpenUnidad = (id) => {
        unidadAbierta != id ? setUnidadAbierta(id) : setUnidadAbierta(null);
    }

    const handleChange = (ev, seccion, index) => {
        setData(ev, seccion, index);
    }

    const deleteGiro = (index) => {
        let newVal = actividades.giros.filter((giro, i) => i != index);
        let e = { target: { name: 'giros', value: newVal } };
        setData(e, 'giros');
        if (giroAbierto == index) {
            setGiroAbierto(null);
        }
    }

    const addGiro = (e) => {
        if (!actividades.giros.includes(e)) {
            let newVal = [...actividades.giros];
            newVal.push(e);
            let ev = { target: { name: 'giros', value: newVal } };
            setGiroAbierto(actividades.giros.length);
            setData(ev, 'giros');
        }
    }

    const deleteProducto = (index) => {
        let newVal = actividades.productos.filter((producto, i) => i != index);
        let e = { target: { name: 'productos', value: newVal } };
        setData(e, 'productos');
        if (productoAbierto == index) {
            setProductoAbierto(null);
        }
    }

    const addProducto = () => {
        let newVal = [...actividades.productos];
        newVal.push({
            descripcion: '',
            nombre: '',
            volumen_anual: ''
        });
        let e = { target: { name: 'productos', value: newVal } };
        setProductoAbierto(actividades.productos.length);
        setData(e, 'productos');
    }

    const deleteUnidad = (index) => {
        let newVal = actividades.unidades_produccion.filter((unidad, i) => i != index);
        let e = { target: { name: 'unidades_produccion', value: newVal } };
        setData(e, 'unidades_produccion');
        if (index == unidadAbierta) {
            setUnidadAbierta(null);
        }
    }

    const addUnidad = () => {
        let newVal = [...actividades.unidades_produccion];
        newVal.push({
            descripcion_larga: '',
            nombre_instalacion: '',
            proceso: '',
            ubicacion: '',
        });
        let e = { target: { name: 'unidades_produccion', value: newVal } };
        setUnidadAbierta(actividades.unidades_produccion.length);
        setData(e, 'unidades_produccion');
    }

    const [mapa, setMapa] = useState('');

    useEffect(() => {
        let obj = {
            target: {
                value: mapa,
                name: 'ubicacion'
            }
        }
        setData(obj);
    }, [mapa]);


    const handleInput = (e, seccion, index = null) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'actividades_economicas';
                imagen.seccion = seccion;
                imagen.indice = index;
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                }, 0);
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (index) => {
        // setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
        let newImgs = imagenes.filter((img, indexImg) => index != indexImg);
        setData({ target: { name: 'imagenes', value: newImgs } });
    }
    if (actividades) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Productos/Servicios:</Typography>
                        {actividades.hasOwnProperty('productos') && Array.isArray(actividades.productos) && actividades.productos.length > 0 && actividades.productos.map((producto, index) => {
                            let imagenes_productos = [];
                            // obtener imagenes del producto/servicio
                            if (imagenes && imagenes.hasOwnProperty('actividades_economicas') && imagenes.actividades_economicas.hasOwnProperty('galeria_productos_servicios')) {
                                imagenes_productos = imagenes.actividades_economicas.galeria_productos_servicios[index] ?? [];
                            }
                            return (
                                <Accordion key={producto.id} expanded={productoAbierto === index} onChange={() => handleOpenProducto(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography variant='body1' fontWeight='bold'>{producto.nombre}</Typography>
                                    </AccordionSummary>
                                    {editable ?
                                        <AccordionDetails>
                                            {/* Datos */}
                                            <Stack direction='column' spacing={1}>
                                                <TextField autoFocus label="Nombre" onChange={(e) => handleChange(e, 'productos', index)} name="nombre" fullWidth value={producto.nombre} />
                                                <TextField label="Descripción" onChange={(e) => handleChange(e, 'productos', index)} name='descripcion' fullWidth value={producto.descripcion} />
                                                <TextField label="Volumen anual" onChange={(e) => handleChange(e, 'productos', index)} name='volumen_anual' fullWidth value={producto.volumen_anual} />


                                            </Stack>
                                            {/* Edicion de imagenes */}
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                                    {Object.values(imagenes).map((image, indexImg) => {
                                                        if (image.paso == 'actividades_economicas' && image.seccion == 'galeria_productos_servicios' && index == image.indice) {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    md={4}
                                                                    key={indexImg}
                                                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(indexImg)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                                                </Grid>
                                                            )
                                                        }
                                                    }
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={imagenes.filter((i) => i.paso == 'actividades_economicas' && i.seccion == 'galeria_productos_servicios' && index == i.indice).length > 2}
                                                            component="label"
                                                            variant="contained"
                                                            startIcon={<Folder />}
                                                        >
                                                            Agregar <input name="imagenes" onInputCapture={(e) => handleInput(e, 'galeria_productos_servicios', index)} type="file" accept='image/*' hidden />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* Eliminar */}
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                                <Button variant='contained' color="error" onClick={() => deleteProducto(index)}>Eliminar Producto/Servicio</Button>
                                            </Box>


                                        </AccordionDetails>
                                        :
                                        <AccordionDetails>
                                            <Typography sx={{ whiteSpace: 'pre-line', mb: 2 }} variant='body1'>{producto.descripcion}</Typography>
                                            <Box sx={{ display: 'flex' }}>
                                                <Typography sx={{ mr: 2 }}>Volumen anual:</Typography>
                                                <Typography>{producto.volumen_anual}</Typography>
                                            </Box>
                                            <Box sx={{ my: 2 }}>
                                                <Typography variant="h6" sx={{ my: 2 }}>Fotogalería: </Typography>
                                                <Grid container spacing={2}>
                                                    {Object.values(imagenes)
                                                        .filter((i) => i.paso === 'actividades_economicas' && i.seccion == 'galeria_productos_servicios' && index == i.indice)
                                                        .map((img, index) => {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={4}
                                                                    key={index}
                                                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                                                >
                                                                    <img
                                                                        src={img.url_img ?? img.dataurl}
                                                                        width="100%"
                                                                        alt={index}
                                                                        style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                                    />
                                                                </Grid>
                                                            )
                                                        })}

                                                </Grid>
                                            </Box>
                                        </AccordionDetails>
                                    }
                                </Accordion>
                            )
                        })}
                        {/* Si es editable, boton para agregar nuevo producto/servicio */}
                        {editable &&
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button variant="contained" onClick={addProducto}>Agregar Producto/Servicio</Button>
                            </Box>
                        }

                    </Grid>
                    {/* Unidades de produccion */}
                    <Grid item xs={12}>
                        <Typography variant="h6">Unidades de producción:</Typography>
                        {actividades.hasOwnProperty('unidades_produccion') && actividades.unidades_produccion.length > 0 && actividades.unidades_produccion.map((unidad, index) => {
                            return (
                                <Accordion key={unidad.id} expanded={unidadAbierta === index} onChange={() => handleOpenUnidad(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography variant='body1' fontWeight='bold'>{unidad.nombre_instalacion}</Typography>
                                    </AccordionSummary>
                                    {editable ?
                                        <AccordionDetails>
                                            <Stack direction='column' spacing={1}>
                                                <TextField label="Nombre" autoFocus onChange={(e) => handleChange(e, 'unidades_produccion', index)} name="nombre_instalacion" fullWidth value={unidad.nombre_instalacion} />
                                                <TextField label="Descripción" onChange={(e) => handleChange(e, 'unidades_produccion', index)} name='descripcion_larga' fullWidth value={unidad.descripcion_larga} />
                                                <TextField label="Proceso" onChange={(e) => handleChange(e, 'unidades_produccion', index)} name='proceso' fullWidth value={unidad.proceso} />
                                                {/* Mapa */}
                                                <Box sx={{ pb: 7 }}>
                                                    <Mapa editable={true} buscador={true} handleSelect={(newVal) => {
                                                        setMapa(() => {
                                                            return `${newVal.lat},${newVal.lng}`;
                                                        })
                                                    }} />
                                                </Box>

                                            </Stack>
                                            {/* Edicion de imagenes */}
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                                    {Object.values(imagenes).map((image, indexImg) => {
                                                        console.log(image);
                                                        if (image.paso == 'actividades_economicas' && image.seccion == 'galeria_unidades_produccion' && index == image.indice) {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    md={4}
                                                                    key={indexImg}
                                                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(indexImg)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                                                </Grid>
                                                            )
                                                        }
                                                    }
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={imagenes.filter((i) => i.paso == 'actividades_economicas' && i.seccion == 'galeria_unidades_produccion' && index == i.indice).length > 2}
                                                            component="label"
                                                            variant="contained"
                                                            startIcon={<Folder />}
                                                        >
                                                            Agregar <input name="imagenes" onInputCapture={(e) => handleInput(e, 'galeria_unidades_produccion', index)} type="file" accept='image/*' hidden />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {/* Eliminar */}
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                                <Button variant='contained' color="error" onClick={() => deleteUnidad(index)}>Eliminar Unidad</Button>
                                            </Box>

                                        </AccordionDetails>
                                        :
                                        <AccordionDetails>
                                            <Typography sx={{ whiteSpace: 'pre-line', mb: 2 }} variant='body1'>{unidad.descripcion_larga}</Typography>
                                            <Box>
                                                <Typography>Proceso: </Typography>
                                                <Typography sx={{ whiteSpace: 'pre-line' }} variant='body1'>{unidad.proceso}</Typography>
                                            </Box>
                                            {/* MAPA */}
                                            <iframe src={`https://maps.google.com/?q=${unidad.ubicacion}&output=embed`} width="100%" height='300px' />
                                            {/* Imagenes */}
                                            <Typography variant="h6" sx={{ my: 2 }}>Fotogalería:</Typography>
                                            <Grid container spacing={2}>
                                                {Object.values(imagenes)
                                                    .filter((i) => i.paso === 'actividades_economicas' && i.seccion == 'galeria_unidades_produccion' && index == i.indice)
                                                    .map((img, index) => {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                sm={6}
                                                                md={4}
                                                                key={index}
                                                                sx={{ display: 'flex', justifyContent: 'center' }}
                                                            >
                                                                <img
                                                                    src={img.url_img ?? img.dataurl}
                                                                    width="100%"
                                                                    alt={index}
                                                                    style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                                />
                                                            </Grid>
                                                        )
                                                    })}

                                            </Grid>
                                        </AccordionDetails>
                                    }
                                </Accordion>
                            )
                        })}

                        {/* Si es editable, boton para agregar nuevo producto/servicio */}
                        {editable &&
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Button variant="contained" onClick={addUnidad}>Agregar Unidad</Button>
                            </Box>
                        }
                    </Grid>
                    {/* Giros */}
                    <Grid item xs={12}>
                        <Typography variant="h6">Giros:</Typography>
                        {actividades.hasOwnProperty('giros') && actividades.giros.length > 0 && actividades.giros.map((giro, index) => {
                            return (
                                <Accordion key={giro.codigo_act} expanded={giroAbierto === index} onChange={() => handleOpenGiro(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography variant='body1' fontWeight='bold'>{giro.nombre_act}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={{ whiteSpace: 'pre-line' }} variant='body1'>{giro.descripcion}</Typography>
                                        {/* incluye excluye */}
                                        <Grid container spacing={2} sx={{ my: 2 }}>
                                            <Grid item xs={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                    <Typography fontWeight="bold">Incluye:</Typography>
                                                </Box>
                                                <Typography>{giro.incluye}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                    <Typography fontWeight="bold">Excluye:</Typography>
                                                </Box>
                                                <Typography>{giro.excluye}</Typography>

                                            </Grid>
                                        </Grid>

                                        {editable &&
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button onClick={() => deleteGiro(index)} variant="contained" color="error">Eliminar giro</Button>
                                            </Box>
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                        {/* En edicion, solo eliminar/agregar distintos giros */}
                        {editable &&
                            <Autocomplete
                                fullWidth
                                disableClearable
                                name="giro_actividad"
                                options={catalogoActividades}
                                getOptionLabel={(option) => option.nombre_act ?? ''}
                                value={giroSeleccionado}
                                onChange={(e, actividad) => {
                                    addGiro(actividad);
                                    setGiroSeleccionado(actividad.codigo_act);
                                }}
                                renderInput={params => (
                                    <TextField {...params} label="Agregar giro" />
                                )}
                            />
                        }
                    </Grid>

                    {/* Fotos */}

                    <Grid item xs={12}>
                        <Typography variant="h6">Fotogalería:</Typography>
                        {!editable ?
                            <Grid container spacing={2}>
                                {Object.values(imagenes)
                                    .filter((i) => i.paso === 'actividades_economicas' && i.seccion == 'galeria_actividades')
                                    .map((img, index) => {
                                        return (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                md={4}
                                                key={index}
                                                sx={{ display: 'flex', justifyContent: 'center' }}
                                            >
                                                <img
                                                    src={img.url_img ?? img.dataurl}
                                                    width="100%"
                                                    alt={index}
                                                    style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                />
                                            </Grid>
                                        )
                                    })}
                            </Grid>
                            :
                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                    {Object.values(imagenes).map((image, indexImg) => {
                                        if (image.paso == 'actividades_economicas' && image.seccion == 'galeria_actividades') {
                                            return (
                                                <Grid
                                                    item
                                                    md={4}
                                                    key={indexImg}
                                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(indexImg)}>
                                                        <Close />
                                                    </IconButton>
                                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                                </Grid>
                                            )
                                        }
                                    }
                                    )}
                                    <Grid item xs={12}>
                                        <Button
                                            disabled={imagenes.filter((i) => i.paso == 'actividades_economicas' && i.seccion == 'galeria_actividades').length > 2}
                                            component="label"
                                            variant="contained"
                                            startIcon={<Folder />}
                                        >
                                            Agregar <input name="imagenes" onInputCapture={(e) => handleInput(e, 'galeria_actividades')} type="file" accept='image/*' hidden />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                    </Grid>

                    {/* Boton para actualizar datos de este tab. (Excepto imagenes y giros, esos se actualizaran al vuelo) */}
                    {editable &&
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Box >
        )
    }
}
export default ActividadesTab